import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  return <section id="comprar" className="w-full bg-white py-8 px-5 flex justify-center scroll-mt-4" data-id="element-145">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} className="w-full max-w-md flex flex-col gap-3" data-id="element-146">
        <h2 className="font-serif font-bold text-petroleo text-2xl leading-tight text-center" data-id="element-147">
          ¿Cuánto vale recuperar el control de tu cuerpo?
        </h2>

        <div className="bg-marfil rounded-xl p-4 border border-salvia-light shadow-sm flex flex-col gap-0" data-id="element-148">
          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-149">
            <span className="text-gray-800 font-medium text-sm" data-id="element-150">
              6 Tomos del Protocolo
            </span>
            <span className="text-gray-800 font-semibold text-sm" data-id="element-151">$15.000</span>
          </div>

          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-152">
            <span className="text-gray-800 font-medium text-sm" data-id="element-153">
              Bonus 1: Botón de Pánico
            </span>
            <div className="flex items-center gap-2" data-id="element-154">
              <span className="text-gray-400 line-through text-xs" data-id="element-155">$5.000</span>
              <span className="text-salvia font-bold text-xs" data-id="element-156">GRATIS</span>
            </div>
          </div>

          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-157">
            <span className="text-gray-800 font-medium text-sm" data-id="element-158">
              Bonus 2: Calculadora de Alacena
            </span>
            <div className="flex items-center gap-2" data-id="element-159">
              <span className="text-gray-400 line-through text-xs" data-id="element-160">$4.000</span>
              <span className="text-salvia font-bold text-xs" data-id="element-161">GRATIS</span>
            </div>
          </div>

          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-162">
            <span className="text-gray-800 font-medium text-sm" data-id="element-163">
              Bonus 3: Guía de Infusiones
            </span>
            <div className="flex items-center gap-2" data-id="element-164">
              <span className="text-gray-400 line-through text-xs" data-id="element-165">$4.000</span>
              <span className="text-salvia font-bold text-xs" data-id="element-166">GRATIS</span>
            </div>
          </div>

          <div className="flex justify-between items-center py-2" data-id="element-167">
            <span className="text-gray-500 font-medium text-sm" data-id="element-168">
              Valor total
            </span>
            <span className="text-gray-400 line-through text-base font-semibold" data-id="element-169">
              $28.000
            </span>
          </div>

          <div className="bg-blush-light rounded-lg mt-1 flex flex-col items-center justify-center gap-2 border border-blush p-3" data-id="element-170">
            <div className="flex items-center gap-2" data-id="element-171">
              <span className="text-petroleo font-medium text-xs" data-id="element-172">
                Hoy pagás
              </span>
              <span className="font-serif font-black text-petroleo text-2xl" data-id="element-173">
                $19.990
              </span>
            </div>
            <CTAButton text="Quiero mi Protocolo Ya!" isCheckout={true} data-id="element-174" />
          </div>
        </div>

        <p className="text-center text-gray-600 text-xs font-medium px-2" data-id="element-175">
          Menos que una consulta médica. Con resultados que podés empezar a ver
          en 5 días.
        </p>
      </motion.div>
    </section>;
}